import { ADOLESCENTE_TEMPLATE } from './adolescente';
import { ADULTO_TEMPLATE } from './adulto';
import { INFANTIL_TEMPLATE } from './infantil';
import type { AnamnesisTemplate, AnamnesisTemplateId } from './types';

const BLANK_TEMPLATE: AnamnesisTemplate = {
    id: 'blank',
    name: 'Em branco',
    sections: [],
};

export const ANAMNESIS_TEMPLATES: AnamnesisTemplate[] = [
    BLANK_TEMPLATE,
    ADULTO_TEMPLATE,
    INFANTIL_TEMPLATE,
    ADOLESCENTE_TEMPLATE,
];

export function getTemplateById(id: AnamnesisTemplateId): AnamnesisTemplate {
    return ANAMNESIS_TEMPLATES.find((template) => template.id === id) ?? BLANK_TEMPLATE;
}

export type { AnamnesisTemplate, AnamnesisTemplateId } from './types';
